import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-receipt-range',
  templateUrl: './receipt-range.component.html',
  styleUrls: [],
  standalone: false
})
export class ReceiptRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
